import { render, staticRenderFns } from "./DataSelection.vue?vue&type=template&id=06d2d7c9&scoped=true&"
import script from "./DataSelection.vue?vue&type=script&lang=ts&"
export * from "./DataSelection.vue?vue&type=script&lang=ts&"
import style0 from "./DataSelection.vue?vue&type=style&index=0&id=06d2d7c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d2d7c9",
  null
  
)

export default component.exports